const AtomsButton = (props) => {
    if (['btn-primary','btn-success','btn-danger','btn-warning'].some(cls => props.class.includes(cls))) return <button className={`btn ${props.class}`} onClick={props.action}>{props.text}</button>
    if (props.class === 'btn-tag') return <button className={`btn ${props.class}`} onClick={props.action}>{props.text}</button>
    return null
}
  
export default AtomsButton
